/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class RetryIncomingEmailsMutation extends Relay.Mutation {

    static propTypes = {
        failed: PropTypes.bool,
        flowDef_id: PropTypes.string,
        flowIncomingEmail_id: PropTypes.string,
        flowStepDef_id: PropTypes.string,
        flow_id: PropTypes.string,
        organisation_id: PropTypes.string,
        sinceDate: PropTypes.string,
        toDate: PropTypes.string,
        unprocessed: PropTypes.bool,
        markAsSuccess: PropTypes.bool,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on FlowDef {
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {retryIncomingEmails}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RetryIncomingEmailsPayload {
                job {
                    id,
                    organisation_id,
                    realId,
                    name
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            flowDef_id: this.props.flowDef_id,
            flowStepDef_id: this.props.flowStepDef_id,
            organisation_id: this.props.organisation_id,
            flowIncomingEmail_id: this.props.flowIncomingEmail_id,
            flow_id: this.props.flow_id,
            sinceDate: this.props.sinceDate,
            toDate: this.props.toDate,
            failed: this.props.failed,
            unprocessed: this.props.unprocessed,
            markAsSuccess: this.props.markAsSuccess,
        };
    }
}
